// src/config.js

const ENV = process.env.REACT_APP_ENV || 'development';

const config = {
  development: {
    API_BASE_URL: 'https://rsaapi.gaadibazaar.co.in/api/',
    PRELOGIN_API_BASE_URL: 'https://api.gaadibazaar.co.in/gaadibazaar_login/',
  },
  staging: {
    API_BASE_URL: 'https://rsaapi.gaadibazaar.co.in/api/',
    PRELOGIN_API_BASE_URL: 'https://api.gaadibazaar.co.in/gaadibazaar_login/',
  },
  production: {
    API_BASE_URL: 'https://rsaapi.gaadibazaar.co.in/api/',
    PRELOGIN_API_BASE_URL: 'https://api.gaadibazaar.co.in/gaadibazaar_login/',
  },
};

export default config[ENV];
